'use client';

import { useCallback, useState } from 'react';
import { canDisableContentFiltering, isBotgoContentFilteringModel } from '../../lib/generation/content-filtering.js';

export function useContentFiltering({ modelKey, subscription } = {}) {
  const [choices, setChoices] = useState({});
  const canUseNoContentFiltering = isBotgoContentFilteringModel(modelKey) && canDisableContentFiltering(subscription);
  const choiceKey = `${subscription?.id || subscription?.userId || 'anonymous'}:${modelKey}:${canUseNoContentFiltering}`;
  const choice = choices[choiceKey];
  const setNoContentFiltering = useCallback((value) => {
    if (!canUseNoContentFiltering) return;
    setChoices(previous => ({ ...previous, [choiceKey]: value }));
  }, [canUseNoContentFiltering, choiceKey]);

  return {
    canUseNoContentFiltering,
    noContentFiltering: canUseNoContentFiltering && (choice ?? true),
    // Omit an untouched setting so the server resolves the current entitlement,
    // including when the subscription request has not finished loading yet.
    noContentFilteringRequest: canUseNoContentFiltering ? choice : undefined,
    setNoContentFiltering,
  };
}
